import { CreateUsernameAccountScreen } from "@/interactors/CreateUsernameAccountScreen";

export default function CreateUsernameAccount() {
  return <CreateUsernameAccountScreen />;
}
